const defaultState = {
  status: "default",
  data: {
    invoice: {},
    payment: {},
    rumbel: [],
    student: 0,
    rumbel: [],
    teacher: 0
  },
  code: 500,
  message: ""
};

let response = {};
const Summary_lib = (state = defaultState, action = {}) => {
  switch (action.type) {
    case "SUCCESS_SUMMARY_DASHBOARD":
      response = {
        ...state,
        data: action.data ? action.data : {},
        code: action.code ? action.code : 500,
        status: "success",

        message: action.message ? action.message : ""
      };

      break;
    case "LOADING_SUMMARY_DASHBOARD":
      response = {
        ...state,
        status: "loading"
      };
      break;
    case "ERROR_SUMMARY_DASHBOARD":
      response = {
        ...state,
        status: "error",
        message: action.message ? action.message : "",
        code: action.code ? action.code : 500
      };
      break;
    default:
      return {
        ...state
      };
  }

  return response;
};

export default Summary_lib;
